import React from 'react';

// Country code to name mapping
const countryNames = {
  'ES': 'Spain', 'DO': 'Dominican Republic', 'US': 'United States', 'ET': 'Ethiopia',
  'FR': 'France', 'DE': 'Germany', 'IT': 'Italy', 'GB': 'United Kingdom', 'PT': 'Portugal',
  'NL': 'Netherlands', 'BE': 'Belgium', 'CH': 'Switzerland', 'AT': 'Austria', 'SE': 'Sweden',
  'NO': 'Norway', 'DK': 'Denmark', 'FI': 'Finland', 'PL': 'Poland', 'CZ': 'Czech Republic',
  'GR': 'Greece', 'TR': 'Turkey', 'RO': 'Romania', 'HU': 'Hungary', 'IE': 'Ireland',
  'MX': 'Mexico', 'BR': 'Brazil', 'AR': 'Argentina', 'CL': 'Chile', 'CO': 'Colombia',
  'PE': 'Peru', 'VE': 'Venezuela', 'EC': 'Ecuador', 'UY': 'Uruguay', 'PY': 'Paraguay',
  'CA': 'Canada', 'AU': 'Australia', 'NZ': 'New Zealand', 'ZA': 'South Africa',
  'EG': 'Egypt', 'MA': 'Morocco', 'KE': 'Kenya', 'NG': 'Nigeria', 'TZ': 'Tanzania',
  'CN': 'China', 'JP': 'Japan', 'KR': 'South Korea', 'IN': 'India', 'TH': 'Thailand',
  'VN': 'Vietnam', 'PH': 'Philippines', 'MY': 'Malaysia', 'SG': 'Singapore', 'ID': 'Indonesia',
  'SA': 'Saudi Arabia', 'AE': 'United Arab Emirates', 'QA': 'Qatar', 'IL': 'Israel',
  'RU': 'Russia', 'UA': 'Ukraine', 'BY': 'Belarus', 'KZ': 'Kazakhstan',
};

/**
 * FlagIcon component using flag-icons library for reliable cross-platform flag display
 * @param {string} countryCode - ISO 3166-1 alpha-2 country code (e.g., "ES", "DO", "US")
 * @param {string} className - Additional CSS classes
 * @param {string} countryName - Optional country name (will extract from countryCode if not provided)
 */
const FlagIcon = ({ countryCode, className = '', countryName }) => {
  if (!countryCode || typeof countryCode !== 'string') {
    // Return globe icon for missing country
    return <span className={`text-gray-400 ${className}`} title="Unknown Country">🌐</span>;
  }

  // Clean and normalize country code - extract first 2 letters
  let code = countryCode.trim().toUpperCase();
  
  // Handle cases like "ES Spain" or "ET Ethiopia"
  if (code.includes(' ')) {
    const parts = code.split(' ');
    code = parts[0].substring(0, 2);
    // If countryName not provided, use the rest as country name
    if (!countryName && parts.length > 1) {
      countryName = parts.slice(1).join(' ');
    }
  } else {
    code = code.substring(0, 2);
  }
  
  if (code.length !== 2 || !/^[A-Z]{2}$/.test(code)) {
    return <span className={`text-gray-400 ${className}`} title="Unknown Country">🌐</span>;
  }

  // Get country name from mapping or use provided name
  const displayName = countryName || countryNames[code] || code;

  // Convert to lowercase for flag-icons class (fi fi-es, fi fi-do, etc.)
  const flagClass = `fi fi-${code.toLowerCase()}`;

  return (
    <span 
      className={`${flagClass} ${className}`}
      title={displayName}
      style={{ fontSize: '1.5em' }}
    />
  );
};

export default FlagIcon;
